import React from "react";
import { ControlLabel } from "react-bootstrap";
import { filterNullableValues } from "../../../../../helpers/filterNullableValues";

const RegistraionEmbedCode = ({ params, eventKey }) => {
    return (
        <>
            <ControlLabel>Код для встраивания</ControlLabel>
            <pre style={{ whiteSpace: "initial" }}>
                &lt;div id=&quot;widget-registration&quot;&gt;&lt;/div&gt;
                <br />
                <br />
                &lt;script src="{location.origin}
                /widget/static/js/embed.js" &gt;&lt;/script&gt;
                <br />
                &lt;script&gt;
                <br />
                {`
                    createWidgetFrame(
                        document.querySelector("#widget-registration"),
                        "${
                            location.origin
                        }/widget-registration/${eventKey}/registration",
                        ${JSON.stringify(
                            filterNullableValues(params),
                            null,
                            4
                        )}
                    );
                `}
                <br />
                &lt;/script&gt;
            </pre>
        </>
    );
};

export default RegistraionEmbedCode;
